import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import * as ViewsActions from './views.actions';
import * as ViewsSelectors from './views.selector';
import type { AssignDriver } from '../../models/assign-driver';
import type { Profile } from '../../models/profile';

@Injectable({ providedIn: 'root' })
export class ViewsFacade {
  private readonly store = inject(Store);

  // profile
  profileImage$ = this.store.select(ViewsSelectors.SELECT_PROFILE_IMAGE);
  profile$ = this.store.select(ViewsSelectors.SELECT_PROFILE);

  setProfileImage(image: File | string): void {
    this.store.dispatch(ViewsActions.setProfileImage({ image }));
  }

  setProfile(profile: Profile): void {
    this.store.dispatch(ViewsActions.setProfile({ profile }));
  }

  // pricing settings
  pricingSettings$ = this.store.select(ViewsSelectors.SELECT_PROFILE_SETTINGS);

  loadPricingSettings(): void {
    this.store.dispatch(ViewsActions.loadPricingSettings());
  }

  //toggle assign driver dialog on assign from booking management
  isAssignDriverOpen$: Observable<boolean> = this.store.select(
    ViewsSelectors.SELECT_IS_ASSIGN_DRIVER_OPRN
  );
  assignDriverBooking$ = this.store.select(ViewsSelectors.SEELCT_ASSIGN_DRIVER_BOOKING);

  openAssignDriver(): void {
    this.store.dispatch(ViewsActions.openAssignDriver());
  }

  closeAssignDriver(): void {
    this.store.dispatch(ViewsActions.closeAssignDriver());
  }

  setAssignDriverBooking(booking: AssignDriver): void {
    this.store.dispatch(ViewsActions.setAssignDriverBooking({ booking }));
  }

  // clear state
  clearViewshState(): void {
    this.store.dispatch(ViewsActions.clearViewsState());
  }

  // list tabs persistence
  selectSelectedListTabFor(featureKey: string): Observable<string | null> {
    return this.store.select(ViewsSelectors.SELECT_SELECTED_LIST_TABFOR(featureKey));
  }

  setSelectedListTab(featureKey: string, tabKey: string | null): void {
    this.store.dispatch(ViewsActions.setSelectedListTab({ featureKey, tabKey }));
  }

  resetSelectedListTabs(): void {
    this.store.dispatch(ViewsActions.resetSelectedListTabs());
  }
}
